import React, {useEffect, useState} from 'react';
import {getOrderExpiry} from '../utils/dates';

const ONE_HOUR_MS = 60 * 60 * 1000;

const formatRemaining = (ms) => {
    if (ms <= 0) return null;
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m left`;
    if (hours > 0) return `${hours}h ${pad(minutes)}m ${pad(seconds)}s left`;
    return `${minutes}m ${pad(seconds)}s left`;
};

const HireCountdown = ({order}) => {
    const expiry = getOrderExpiry(order);
    const [remaining, setRemaining] = useState(expiry ? expiry - Date.now() : null);

    useEffect(() => {
        if (!expiry) return;
        const tick = () => setRemaining(expiry - Date.now());
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [expiry?.getTime()]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!expiry) return null;

    const expired = remaining !== null && remaining <= 0;
    const urgent = !expired && remaining !== null && remaining < ONE_HOUR_MS;

    return (
        <div className="d-flex align-items-center gap-2 mt-2">
            <span className={`fas fa-hourglass-half ${urgent || expired ? 'text-danger' : 'text-primary'}`} />
            {expired ? (
                <span className="text-danger fw-bold small">Hire period expired</span>
            ) : (
                <>
                    <span className={`fw-bold small ${urgent ? 'text-danger' : 'text-primary'}`}>
                        {formatRemaining(remaining)}
                    </span>
                    <span className="text-white-50 small">
                        · expires {expiry.toLocaleString()}
                    </span>
                </>
            )}
        </div>
    );
};

export default HireCountdown;
